import React, { useState } from 'react'
import { FormModal } from 'transfix-ui/components/Modals'
import { Spinner } from 'transfix-ui/components/Spinner'
import { useDeleteRequestForProposal } from 'apps/marketplace/apiTypes/requestForProposals'

interface IDeleteConfirmationModalProps {
  rfpId: number
  openConfirmation: boolean
  onRefetch: () => void
  onCloseAction: () => void
}

export const DeleteConfirmationModal = ({
  onCloseAction,
  onRefetch,
  openConfirmation,
  rfpId,
}: IDeleteConfirmationModalProps) => {
  const [errorMessage, setErrorMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const { mutate: destroyRequestForProposal } = useDeleteRequestForProposal({})

  const deleteRequestForProposal = () => {
    setIsLoading(true)
    destroyRequestForProposal(rfpId)
      .then(() => {
        onRefetch()
        onCloseAction()
      })
      .catch(err => {
        setErrorMessage(err.data?.errors?.join(', ') || 'An unknown error occurred.')
        setIsLoading(false)
      })
  }

  return (
    <FormModal
      size={4}
      onClose={onCloseAction}
      open={openConfirmation}
      error={errorMessage}
      title='Are you sure?'
      className='ph0'
      actions={[
        {
          type: 'dismiss',
          label: 'Cancel',
          dataTest: 'cancel-button',
          action: onCloseAction,
          disabled: isLoading,
        },
        {
          label: 'Delete',
          type: 'confirm',
          dataTest: 'delete-confirm-button',
          action: deleteRequestForProposal,
          disabled: isLoading,
        },
      ]}>
      <span>This action cannot be undone. We will delete all data associated with this RFP.</span>
      {isLoading && (
        <div className='mv3'>
          <Spinner position='relative' />
        </div>
      )}
    </FormModal>
  )
}
